import React, { useState, useContext, useRef, useEffect } from 'react';
import { IonPage, IonHeader, IonToolbar, IonButtons, IonTitle, IonContent, IonList, IonItem, IonLabel, IonInput, IonButton, IonToast, IonLoading, IonSelect, IonSelectOption, IonDatetime, IonTextarea, IonIcon } from '@ionic/react';
import { withRouter } from 'react-router';

import Firebase, { withFirebase } from '../services/Firebase';
import { videocam } from 'ionicons/icons';
import { AuthUserContext } from '../services/Session';

interface FormProps {
  history: any,
  firebase: Firebase,
}

const NewMeal: React.FC<FormProps> = ({ history, firebase }) => {

  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');
  const [type, setType] = useState('');
  const [photoURL, setPhoto] = useState<File>();
  const [createdAt, setCDate] = useState('');
  const [error, setError] = useState<Error>();
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState<any[]>([]);
  const isInvalid = name === '' || type === '' || createdAt === '' || !photoURL || photoURL.size === 0;
  const inputFileRef = useRef(null);
  const user = useContext(AuthUserContext);
  
  useEffect(() => {
    if(!user) return;
    setLoading(true);
    const unsubscribe = firebase
    .groups()
    .where('userId', '==', user.uid)
    .limit(1)
    .orderBy('name', 'asc')
    .onSnapshot((querySnapshot) => {
      const groups:any[] = [];
      querySnapshot.forEach((doc) => {
        const group = {
          id: doc.id,
          ...doc.data()
        };
        groups.push(group);
      });
      setLoading(false);
      setGroups(groups);
    }, error => {
      setLoading(false);
      setError(error);
    })
    return () => {
      // Nettoyage de l'abonnement
      unsubscribe();
    };
  }, [firebase, user]);
  
  const handlePicture = () => {
    ((inputFileRef || {}).current || { click: () => {}}).click()
  }

  const handlePictureChange = (e: any) => {
    setPhoto(e.target.files[0]);
  }

  const uploadPicture = () => {
    if (!photoURL || !user) return
    setLoading(true)
    const storageRef = firebase.storage.ref(`meals/${user.uid}/${(photoURL || { name: ''}).name}${Date.now()}`);
    const uploadTask = storageRef.put(photoURL);
    uploadTask.on(firebase.TaskEvent.STATE_CHANGED, (snapshot: any) => {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.info('Upload is ' + progress + '% done');
      switch (snapshot.state) {
        case firebase.TaskState.PAUSED: // or 'paused'
          console.info('Upload is paused');
          break;
        case firebase.TaskState.RUNNING: // or 'running'
          console.info('Upload is running');
          break;
      }
    }, (error: any) => {
      console.error(error);
      setError(error);
      setLoading(false);
    }, () => {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then((downloadURL: any) => {
        postNewMeal(downloadURL)
      });
    });
  }

  const postNewMeal = (photoURL: string) => {
    if (!photoURL || !user) return
    const docRef = firebase.meals().doc();
    docRef.set({
      name,
      desc,
      type,
      createdAt: firebase.Timestamp.fromDate(new Date(createdAt)),
      insertedAt: firebase.Timestamp.fromDate(new Date()),
      photoURL,
      groupIds: groups.map(group => group.id),
      userId: user.uid
    })
    .then (() => {
      setLoading(false);
      history.goBack();
    })
    .catch(error => {
      console.error(error);
      setError(error);
      setLoading(false);
    });
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='end'>
            <IonButton onClick={uploadPicture} disabled={isInvalid}>Valider</IonButton>
          </IonButtons>
          <IonButtons slot='start'>
            <IonButton routerLink='/home/meals'>Annuler</IonButton>
          </IonButtons>
          <IonTitle>Nouveau repas</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding ion-text-center">
        <IonLoading isOpen={loading} />
        <IonToast
          isOpen={!!error}
          message={(error || { message: 'Oups, une erreure s\'produite...'}).message}
          duration={8000}
          color="danger"
        />
        <IonList className='margin-form'>
          <IonItem>
            <IonLabel position="stacked">
              Nom
            </IonLabel>
            <IonInput type="text" value={name} onIonChange={({ detail: { value }}) => setName(value || '')}/>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              Type
            </IonLabel>
            <IonSelect value={type} interface="action-sheet" onIonChange={({ detail: { value }}) => setType(value || '')}>
              <IonSelectOption value='breakfast'>Petit Déjeuner</IonSelectOption>
              <IonSelectOption value='lunch'>Déjeuner</IonSelectOption>
              <IonSelectOption value='dinner'>Diner</IonSelectOption>
              <IonSelectOption value='snack'>Collation</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              Date
            </IonLabel>
            <IonDatetime
              displayFormat={'DD MMM YYYY HH:mm'}
              value={createdAt}
              onIonChange={({ detail: { value }}) => setCDate(value || '')}></IonDatetime>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              Remarques
            </IonLabel>
            <IonTextarea value={desc} onIonChange={({ detail: { value }}) => setDesc(value || '')}></IonTextarea>
          </IonItem>
        </IonList>
        {
          photoURL
          ? <img src={window.URL.createObjectURL(photoURL)} alt={name}/>
          : <div>
            <input ref={inputFileRef} hidden type="file" onChange={handlePictureChange} accept="image/*" multiple={false} />
            <IonButton expand='block' size="default" className='ion-margin-top' onClick={handlePicture}>
                <IonIcon icon={videocam} slot="start"></IonIcon>
                <IonLabel>Prendre une photo</IonLabel>
            </IonButton>
          </div>
        }
      </IonContent>
    </IonPage>
  );
};

export default withRouter(withFirebase(NewMeal));
